import * as Sentry from "@sentry/react";

const DSN = import.meta.env.VITE_SENTRY_DSN;

export function initSentry() {
  if (!DSN) {
    console.warn("[Sentry] DSN not configured – skipping initialization");
    return;
  }

  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE, // "development" | "production"
    // Only send 20% of transactions in production to control costs
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    // Replay only on errors
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: import.meta.env.PROD ? 1.0 : 0,
    // Filter noisy errors
    ignoreErrors: [
      "ResizeObserver loop",
      "Non-Error promise rejection",
      "dynamically imported module",
      "Failed to fetch",
      "Load failed",
      "Network request failed",
    ],
    beforeSend(event) {
      // Don't send events in development
      if (import.meta.env.DEV) {
        console.info("[Sentry] Event suppressed in dev:", event.exception?.values?.[0]?.value);
        return null;
      }
      return event;
    },
  });
}

export { Sentry };
